import { render } from "./MyLoading.vue?vue&type=template&id=0642eda4&scoped=true"
import script from "./MyLoading.vue?vue&type=script&lang=js"
export * from "./MyLoading.vue?vue&type=script&lang=js"

import "./MyLoading.vue?vue&type=style&index=0&id=0642eda4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0642eda4"]])

export default __exports__